import { SideBarLinks, UpgradeButton, HelperText } from '../styles';
import SideBarItem from '../SideBarItem';
import { useRoutesConst } from '../../../routes';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAppointmentCount,
} from '../../../store/appointmentCount.slice';
import { getPermissions, getProfileData } from '../../../../src/store/profile.slice';
import { removeAuthToken } from '../../../utils/auth-token';
import { Link, useNavigate } from 'react-router-dom';
import { BsRocketTakeoffFill } from 'react-icons/bs';
import { closeSideMenu } from '../../../store/sideMenu.slice';
import { isBasicPlanValue } from '../../../app-constants/subscription-plan.enum';

export default function SideBarLinksSection() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const permissions = useSelector(getPermissions);
  const appointmentCount = useSelector(getAppointmentCount);
  const profile = useSelector(getProfileData);
  const { ROUTES } = useRoutesConst();
  
  const logout = () => {
    localStorage.removeItem('email');
    removeAuthToken();
    localStorage.removeItem('isNew');
    localStorage.removeItem('active_tenant_id');
  };

  // Check if user is on trial or basic plan
  const subscriptionInfo = profile?.subscription_info;
  const statusValue = Number(subscriptionInfo?.status_value);
  const planValue = Number(subscriptionInfo?.plan_value);
  const isTrial = statusValue === 1;
  const isActive = statusValue === 2;
  const isBasicPlan = isBasicPlanValue(planValue);
  const shouldShowUpgradeButton = !isActive && (isTrial || isBasicPlan);

  const handleUpgradeClick = () => {
    dispatch(closeSideMenu());
    navigate(ROUTES.plans.to());
  };

  return (
    <SideBarLinks>
      {Array.isArray(permissions) &&
        permissions.includes('appointments.index') && (
          <SideBarItem
            routesTo={`${ROUTES.appointments.to()}?status[0]=upcoming&status[1]=approved`}
            routes={ROUTES.appointments}
            count={appointmentCount}
          />
        )}
      {Array.isArray(permissions) && permissions.includes('events.index') && (
        <SideBarItem routes={ROUTES.events} />
      )}
      {Array.isArray(permissions) &&
        permissions.includes('schedules.index') && (
          <SideBarItem routes={ROUTES.reservationTimes} />
        )}
      {Array.isArray(permissions) &&
        permissions.includes('workflows.index') && (
          <SideBarItem routes={ROUTES.workflows} />
        )}
      {Array.isArray(permissions) && permissions.includes('users.index') && (
        <SideBarItem routes={ROUTES.clients} />
      )}
      {Array.isArray(permissions) && permissions.includes('forms.index') && (
        <SideBarItem routes={ROUTES.models} />
      )}
      {Array.isArray(permissions) && permissions.includes('teams.index') && (
        <SideBarItem routes={ROUTES.team} />
      )}
      {Array.isArray(permissions) && permissions.includes('statistics') && (
        <SideBarItem routes={ROUTES.analytics} />
      )}
      <SideBarItem routes={ROUTES.settings} />
      {shouldShowUpgradeButton && (
        <UpgradeButton activeLink={false}>
          <Link to={ROUTES.plans.to()} onClick={handleUpgradeClick}>
            <div>
              <BsRocketTakeoffFill size={16} />
            </div>
            <div className="button-content">
              <p>ترقية الخطة</p>
              <HelperText>مميزات أكثر بدون إالتزام</HelperText>
            </div>
          </Link>
        </UpgradeButton>
      )}
    </SideBarLinks>
  );
}
